var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconClipboard = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-3.25 -1.083)" },
                React.createElement("path", { d: "M22.6,7.4h2.2c1.2,0,2.2,1,2.2,2.2v15.2c0,1.2-1,2.2-2.2,2.2h-13c-1.2,0-2.2-1-2.2-2.2V9.6\n\t\tc0-1.2,1-2.2,2.2-2.2h2.2" }),
                React.createElement("path", { d: "M15,5.3h6.5c0.6,0,1.1,0.5,1.1,1.1l0,0v2.2c0,0.6-0.5,1.1-1.1,1.1l0,0H15\n\t\tc-0.6,0-1.1-0.5-1.1-1.1l0,0V6.3C13.9,5.7,14.4,5.3,15,5.3L15,5.3z" })))));
});
export default IconClipboard;
//# sourceMappingURL=IconClipboard.js.map